var React = require('react');

function ArrowR (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M77.83,9.6l-6.78,5.18a1.12,1.12,0,0,1-1.49-.22A1.23,1.23,0,0,1,69.77,13L75.61,8.6H0V6.4H75.71L69.88,2A1.21,1.21,0,0,1,69.67.44,1,1,0,0,1,70.52,0a1.45,1.45,0,0,1,.63.22l6.79,5.07A2.74,2.74,0,0,1,79.11,7.5,3.19,3.19,0,0,1,77.83,9.6Z","transform":"translate(0 0)","className":"fill-current"}));
}

ArrowR.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 79.11 14.97"};

module.exports = ArrowR;

ArrowR.default = ArrowR;
